import React from 'react';

import { t } from 'state/intl/translations';

import { FriesSvg as ErrorEmptyStateImage } from '../../../../../components/svgs/fries';

import { EmptyStateWrapper, HeaderText, ImageWrapper, StyledActionButtonLink } from './styled';

interface IErrorStateProps {
  onRefresh?: () => void;
}

const ErrorState: React.FC<React.PropsWithChildren<IErrorStateProps>> = ({ onRefresh }) => {
  return (
    <EmptyStateWrapper>
      <ImageWrapper>
        <ErrorEmptyStateImage />
      </ImageWrapper>
      <HeaderText>{t('recentItemsFailed')}</HeaderText>
      {!!onRefresh && (
        <StyledActionButtonLink onPress={onRefresh}>{t('refresh')}</StyledActionButtonLink>
      )}
    </EmptyStateWrapper>
  );
};

export default ErrorState;
